import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./content-list-util.i18n.json'));

type SortOptions = {
  [x: string]: string
};

export const CONTENT_LIST_SORT_OPTIONS: SortOptions = {
  'campaign_start_date.desc': __t('content_list_util.sort.campaign_start_date.descending'),
  'campaign_start_date.asc': __t('content_list_util.sort.campaign_start_date.ascending')
};
